import React, { Component } from 'react';
import { OtherTeamNameComponent } from 'react/match/active/OtherTeamNameComponent.jsx';
import { MyTeamNameComponent } from 'react/match/active/MyTeamNameComponent.jsx';

import { MatchSelectedCharacterPlayerComponent } from 'react/match/active/MatchSelectedCharacterPlayerComponent.jsx';
import { JqueryClassFaker } from '../../../components/JqueryClassFaker';
import CharacterLockInputComponent from "./CharacterLockInputComponent";

export default class MatchSelectedCharactersComponent extends Component {
	static defaultProps = {
		showLockControls: true,
		showVotes: false,
		clickable: true,
		showCharacterNames: true,
		showPlayerNames: true,
		perspectivePlayer: null,
	};

	constructor(props) {
		super(props);
		this.forceUpdate = this.forceUpdate.bind(this);
	}

	render() {
		const {
			match, game, clickable, apmHeading, showLockControls, onCharacterClick, showVotes,
			showCharacterNames, showPlayerNames, perspectivePlayer
		} = this.props;
		if(!game) {
			return null;
		}
		const teamComponents = [];
		for(let team of match.getTeamsPrioritizeMineFirst(perspectivePlayer)) {
			teamComponents.push(
				<MatchSelectedCharacterTeamComponent
					showVotes={showVotes}
					onCharacterClick={onCharacterClick}
					clickable={clickable}
					key={team.number}
					teamNumber={team.number}
					game={game}
					match={match}
					apmHeading={apmHeading}
					showLockControls={showLockControls}
					showCharacterNames={showCharacterNames}
					showPlayerNames={showPlayerNames}
					parentShouldUpdate={this.forceUpdate}
				/>
			);
		}
		return (
			<React.Fragment>
				{match.containsMeAsPlayer() && showLockControls &&
				<CharacterLockInputComponent
					title='Lock '
					active={!!match.character_lock_enabled}
					match={match}
					character={game.getMyCurrentCharacter()}
				/>
				}
				<div className='selected_characters'>
					{teamComponents}
				</div>
			</React.Fragment>
		);
	}
}

class MatchSelectedCharacterTeamComponent extends Component {
	static defaultProps = {
		clickable: true,
	};

	constructor(props) {
		super(props);
		const { clickable } = this.props;

		this.onTeamClick = clickable ? this.teamClick.bind(this) : undefined;
		this.state = {
			makingTeamSelection: false
		};
	}

	teamClick(isMyTeam) {
		const { match, game, onCharacterClick, teamNumber, parentShouldUpdate } = this.props;
		if(onCharacterClick) {

			onCharacterClick({
				teamNumber
			});
			return;
		}
		let selectedResult = null;
		if(!game.isAtPlayGamePhase() || match.isAutoReportedOnly() || !match.containsMeAsPlayer()) {
			return;
		}

		console.log(teamNumber, isMyTeam);
		const theTeam = game.teams[match.getMyTeamNumber()];

		if(isMyTeam) {
			selectedResult = WIN_MATCH;
		}
		else {
			selectedResult = LOSE_MATCH;
		}
		if(game.getMyMatchGameTeam()) {
			theTeam.updatedPendingDecision(selectedResult);
		}


		this.setState({
			makingTeamSelection: true
		});

		parentShouldUpdate();
		match.report(selectedResult)
			.finally(() => {
				this.setState({
					makingTeamSelection: false
				});
				theTeam.removePendingDecision();
				parentShouldUpdate();
			});
	}

	renderVote(playerComponent, teamThatIsVoting, displayedTeamNumber) {
		let theCheck = null;
		if(teamThatIsVoting.reportedNothing()) {
			theCheck = (
				<span className='report_text'>
					<span className='no_vote'>
					No Vote Yet
					</span>
				</span>
			);
		}
		else if(teamThatIsVoting.number === displayedTeamNumber) {
			if(teamThatIsVoting.reportedWin()) {
				theCheck = (
					<span className='report_text emphasized_bright'>
						Voted <i className='fa fa-check' />
					</span>
				);
			}
		}
		else {
			if(teamThatIsVoting.reportedLoss()) {
				theCheck = (
					<span className='report_text emphasized_bright'>
						Voted <i className='fa fa-check' />
					</span>
				);
			}
		}
		if(!theCheck) {
			theCheck = (
				<span className='report_text'>
					<span className='no_vote'>
						Voted
					</span>
				</span>
			);
		}
		return (
			<React.Fragment>
				{playerComponent}
				{' '}
				{theCheck}
			</React.Fragment>
		);
	}

	render() {
		const { showCharacterNames, showPlayerNames, match, game, showVotes, teamNumber, apmHeading, showLockControls } = this.props;
		const teams = match.getTeams();

		const classes = new JqueryClassFaker();

		const isMyTeam = match.getMyTeamNumber() == teamNumber;
		if(!teams[teamNumber]) {
			return null;
		}

		classes.add(`team_${teamNumber}_characters`);
		classes.add(isMyTeam ? 'my_team' : 'other_team');
		classes.toggleClass('victorious', game.teamWon(teamNumber));
		classes.toggleClass('defeated', game.teamLost(teamNumber));


		const myTeam = game.teams[match.getMyTeamNumber()];
		const otherTeam = game.teams[match.getOtherTeamNumber()];

		return (
			<div
				className={`team_characters ${classes.toString()}`}>
				<div className='characters_container'>
					{teams[teamNumber].players.map((player) =>
						<MatchSelectedCharacterPlayerComponent
							key={player.id + '-' + game.getPlayerCharacter(player) + '-' + game.getPlayerRandomCharacter(player)}
							disabled={this.state.makingTeamSelection}
							player={player}
							match={match}
							game={game}
							matchGamePlayer={game.players[player.id]}
							characterId={game.getPlayerCharacter(player)}
							randomCharacterId={game.getPlayerRandomCharacter(player)}
							teamNumber={teamNumber}
							onClick={this.onTeamClick}
							apmHeading={apmHeading}
							showCharacterName={showCharacterNames}
							showPlayerName={showPlayerNames}
						/>
					)}
				</div>
				{showVotes && game.isAtPlayGamePhase() &&
				<div className='reports'>
					<div className='other_report_pick'>
						{this.renderVote(<OtherTeamNameComponent match={match} />, otherTeam, teamNumber)}
					</div>
					<div className='my_report_pick'>
						{this.renderVote(<MyTeamNameComponent match={match} />, myTeam, teamNumber)}
					</div>
				</div>
				}
			</div>
		);
	}

}